import React from "react";

import Field from "./index";

export default function Number({ max, min, step = 0.01, ...props }) {
  const inputProps = {
    min,
    max,
    step,
  };

  return <Field inputProps={inputProps} type="number" {...props} />;
}
